// extracted by mini-css-extract-plugin
export default {"list-tags":"list-tags_list-tags__8p-++","inline":"list-tags_inline__nHiTO","ul":"list-tags_ul__VNKRL","selected":"list-tags_selected__Oiox-"};